module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-entities-search callout"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-12 medium-3"
  }, [_c('search-input-form', {
    attrs: {
      "placeholder": 'Client'
    },
    on: {
      "filteredSearch": _vm.setClientComponent
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.component = null
      }
    }
  })], 1), _c('div', {
    staticClass: "column small-12 medium-3"
  }, [_c('search-input-form', {
    attrs: {
      "placeholder": 'Driver'
    },
    on: {
      "filteredSearch": _vm.setDriverComponent
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.component = null
      }
    }
  })], 1), _c('div', {
    staticClass: "column small-12 medium-3"
  }, [_c('search-input-form', {
    attrs: {
      "placeholder": 'Reservation (id or client name)'
    },
    on: {
      "filteredSearch": _vm.setReservationComponent
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.component = null
      }
    }
  })], 1), _c('div', {
    staticClass: "column small-12-medium-3"
  }, [_c('search-input-form', {
    attrs: {
      "placeholder": "Vehicle license plate"
    },
    on: {
      "filteredSearch": _vm.setVehicleComponent
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.component = null
      }
    }
  })], 1)]), (_vm.component) ? _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d599b00!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/EntitiesSearch.vue
// module id = 2258
// module chunks = 1